<template>
    <div class="col-12 footer text-center">
        <div class="first-footer-area">
            <p>{{ $t('info.footer_info')}}</p>
        </div>
        <div class="second-footer-area">
            <b-row>
                <b-button class="footer-item" @click.stop="showInfo">{{ $t('common.fair_donation') }}</b-button>
                <b-button class="footer-item" :href="`mailto:${this.contactEmail}`">{{ $t('common.fair_donation_contact_email') }}</b-button>
                <b-button class="footer-item" @click.stop="showPrivacyPolicy">{{ $t('privacy.title') }}</b-button>
                <b-button class="footer-item" @click.stop="showTerms">{{ $t('privacy.terms') }}</b-button>
                <b-button class="footer-item" @click.stop="showFaq">{{ $t('breadcrumbs.faq') }}</b-button>
                <b-button class="footer-item" @click.stop="showLicense">{{ $t('breadcrumbs.funds') }}</b-button>
                <div class="footer-item">
                    <b-button class="lang-button" @click.stop="openFacebook()">
                        <img class="mx-auto" style="width: 1.4em; height: auto" src="../assets/facebook.png" alt="Facebook"/>
                    </b-button>
                    <b-button class="lang-button" @click.stop="openInstagram()">
                        <img class="mx-auto" style="width: 1.4em; height: auto" src="../assets/instagram.png" alt="Instagram"/>
                    </b-button>
                </div>
                <div class="footer-item">
                    <b-button class="lang-button" @click.stop="changeLocale('fi')">
                        <img class="mx-auto" src="../assets/finland.png" alt="finnish"/>
                    </b-button>
                    <b-button class="lang-button" @click.stop="changeLocale('en')">
                        <img class="mx-auto" src="../assets/uk.png" alt="english"/>
                    </b-button>
                </div>
            </b-row>
            <p class="footer-item-no-underline">© All-In-One-Media Oy 2025</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "FooterArea",
    data() {
        return {
            contactEmail: this.$t('common.fair_donation_contact_email')
        }
    },
    methods: {
        showPrivacyPolicy: function () {
            const url = process.env.VUE_APP_FAIR_PRIVACY_POLICY_LINK;
            window.open(url, '_blank');
        },
        showTerms: function () {
            const url = process.env.VUE_APP_FAIR_TERMS_LINK;
            window.open(url, '_blank');
        },
        showInfo: function () {
            this.$router.push({name: 'info-view'})
        },
        changeLocale: function (locale) {
            this.$i18n.locale = locale;
            localStorage.setItem('language', locale);
        },
        showFaq : function () {
            this.showLogIn = false
            this.$router.push({name: 'faq-view'})
        },
        showLicense : function () {
            this.showLogIn = false
            this.$router.push({name: 'fund-raising-info-view'})
        },
        openFacebook() {
            window.open('https://www.facebook.com/fairdonationry/', '_blank');
        },
        openInstagram() {
            window.open('https://www.instagram.com/fairdonationry/', '_blank');
        }
    }
}
</script>

<style scoped>

</style>